import "./DirectPartMarkingDPM.module.css";
import Header from "@/reusable_sections/Header";
import ServiceHeroDpm from "./sections/ServiceHeroDpm";
import WhatIsDirectPartMarking from "./sections/WhatIsDirectPartMarking";
import MarkingStandardsSpecifications from "./sections/MarkingStandardsSpecifications";
import Capabilities from "./sections/Capabilities";
import HowToOrder from "./sections/HowToOrder";
import ComplianceStandards from "./sections/ComplianceStandards";
import Faq from "./sections/Faq";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function DirectPartMarkingDPMPage() {
  return <div>
      <Header />
      <ServiceHeroDpm />
      <WhatIsDirectPartMarking />
      <MarkingStandardsSpecifications />
      <Capabilities />
      <HowToOrder />
      <ComplianceStandards />
      <Faq />
      <CallToAction />
      <Footer />
    </div>;
}